export const PIXELS_PER_SECOND = 10;
export const SAMPLES_PER_SECOND = 48000;
export const MASTERGAIN_VALUE = 1;
export default {
    PIXELS_PER_SECOND,
    SAMPLES_PER_SECOND,
    MASTERGAIN_VALUE
}